<div class="password-input">
  <input
    [id]="id()"
    [type]="visible() ? 'text' : 'password'"
    class="form-control password-input-control"
    [placeholder]="placeholder()"
    [formField]="formField()"
  />

  <button
    type="button"
    class="password-toggle"
    (click)="toggleVisibility()"
    [attr.aria-label]="visible() ? 'Hide password' : 'Show password'"
    [attr.aria-pressed]="visible()"
  >
    @if (visible()) {
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M3 3L21 21M10.58 10.58C10.21 10.95 10 11.45 10 12C10 13.1046 10.8954 14 12 14C12.55 14 13.05 13.79 13.42 13.42M9.88 5.09C10.58 4.96 11.28 4.89 12 4.89C17 4.89 20.27 9.21 21 12C20.73 12.88 20.17 13.88 19.38 14.83M6.61 6.61C4.61 8.06 3.34 10.01 3 12C3.73 14.79 7 19.11 12 19.11C13.55 19.11 14.95 18.78 16.18 18.22"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    } @else {
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M2 12C2.73 9.21 6 4.89 12 4.89C18 4.89 21.27 9.21 22 12C21.27 14.79 18 19.11 12 19.11C6 19.11 2.73 14.79 2 12Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </button>
</div>
